var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _c(
        "form",
        {
          staticClass: "form",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            }
          }
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "input-group m-2" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", readonly: "" },
                domProps: { value: _vm.contestURL }
              }),
              _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "clipboard",
                        rawName: "v-clipboard",
                        value: _vm.contestURL,
                        expression: "contestURL"
                      }
                    ],
                    staticClass: "btn btn-primary",
                    attrs: {
                      "copy-to-clipboard": "",
                      type: "button",
                      title: _vm.T.contestEditCopyContestLink
                    },
                    on: { click: _vm.onCopyContestLink }
                  },
                  [_c("font-awesome-icon", { attrs: { icon: "clipboard" } })],
                  1
                )
              ])
            ]),
            _c("label", [_vm._v(_vm._s(_vm.T.contestNewFormAdmissionMode))]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentAdmissionMode,
                    expression: "currentAdmissionMode"
                  }
                ],
                staticClass: "form-control",
                attrs: { name: "admission-mode" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.currentAdmissionMode = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c(
                  "option",
                  { domProps: { value: _vm.AdmissionMode.Private } },
                  [_vm._v(" " + _vm._s(_vm.T.wordsPrivate) + " ")]
                ),
                _c(
                  "option",
                  { domProps: { value: _vm.AdmissionMode.Registration } },
                  [_vm._v(" " + _vm._s(_vm.T.wordsRegistration) + " ")]
                ),
                _vm.shouldShowPublicOption
                  ? _c(
                      "option",
                      { domProps: { value: _vm.AdmissionMode.Public } },
                      [_vm._v(" " + _vm._s(_vm.T.wordsPublic) + " ")]
                    )
                  : _vm._e()
              ]
            ),
            _c(
              "p",
              { staticClass: "form-text text-muted" },
              [
                _c("omegaup-markdown", {
                  attrs: { markdown: _vm.admissionModeDescription }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _vm.currentAdmissionMode !== _vm.AdmissionMode.Private
                ? _c("omegaup-toggle-switch", {
                    attrs: {
                      value: _vm.currentDefaultShowAllContestantsInScoreboard,
                      "checked-value":
                        _vm.currentDefaultShowAllContestantsInScoreboard,
                      "text-description":
                        _vm.T.showDefaultAllContestantsInScoreboard
                    },
                    on: {
                      "update:value": function($event) {
                        _vm.currentDefaultShowAllContestantsInScoreboard = $event
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-primary change-admission-mode",
              attrs: { type: "submit" }
            },
            [_vm._v(" " + _vm._s(_vm.T.wordsSaveChanges) + " ")]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }